import { useLocation } from "react-router-dom";
import SEO from "./SEO";
import SEOConfig from "./SEOConfig";

// Head tags for the 404 page. The whole point of this file is the `robots` value: Amplify still
// answers 200 for unknown paths (the SPA fallback rewrite), so `noindex` is the only thing that
// keeps URLs like /teams/ out of the index. Googlebot renders JavaScript, so it sees this.
//
// `follow`, not `nofollow` — crawlers should still traverse the recovery links on the page.
//
// The canonical is deliberately self-referencing. SEO.jsx always emits one, falling back to the
// site root, and a 404 that canonicalises to the homepage would claim every junk URL is a
// duplicate of `/`. Pointing it at itself is inert next to `noindex`.
const NotFoundSEO = ({ title = "Сторінку не знайдено" }) => {
  const location = useLocation();
  const { siteUrl } = SEOConfig;
  const currentUrl = `${siteUrl}${location.pathname}`;

  return (
    <SEO
      title={title}
      description="Такої сторінки на сайті Slick Racing Ukraine немає. Можливо, вона переїхала або в посиланні є помилка."
      url={currentUrl}
      canonical={currentUrl}
      robots="noindex, follow"
      type="website"
      lang="uk"
    />
  );
};

export default NotFoundSEO;
